import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant21PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black }, ref)=>jsx("svg", {
        viewBox: "0 0 722 711",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M805.616 480.539C759.198 537.188 712.691 600.85 642.193 628.862C610.831 641.326 575.18 645.079 543.103 634.625C498.025 619.882 467.512 578.602 461.659 532.407C455.092 480.673 492.486 433.764 527.332 399.051C562.492 364.07 602.745 332.619 627.227 289.462C667.703 218.16 635 121.303 558.561 90.388C509.909 70.7308 452.59 74.7962 409.881 106.203C364.803 139.397 355.689 199.262 347.201 250.996C339.115 300.318 327.722 353.616 289.435 385.693C245.475 422.55 175.289 417.502 130.748 381.36C86.2064 345.217 66.3258 284.369 70.7487 227.184C74.6355 176.746 95.5436 129.747 122.84 87.7521C145.67 52.6372 208.723 -62.2241 245 -85.5",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant21PathwayIllustration as default };
